<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="elevation-8">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Системные настройки') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-row
              v-for="task in tasks"
              :key="task.id"
              class="text-left pa-2 ma-2">
            <v-col v-if="isMainAdmin" class="align-self-center ml-2" cols="7">
              <validatable-checkbox
                  v-model="task.execute"
                  :label="task.description" />
            </v-col>
            <v-col v-if="task.model">
              <validatable-text-input
                  v-if="task.model.hasOwnProperty('interval')"
                  v-model="task.model.interval"
                  :rules="{ required: true,
                            max: 20,
                            regex: /^[0-9]{1,11}$/ }"
                  solo
                  :label="$t('Интервал (дни)')"
                  data-type="int" />
              <validatable-date-time-picker
                  v-if="task.model.hasOwnProperty('date')"
                  v-model="task.model.date"
                  :rules="{ required: true }"
                  :label="$t('Дата')" />
              <validatable-enum-combobox
                  v-if="task.model.hasOwnProperty('lotType')"
                  v-model="task.model.lotType"
                  dense
                  :label="$t('Тип лота')"
                  rules="required"
                  :values-enum="LOT_TYPE_ENUM" />
              <validatable-text-input
                  v-if="task.model.hasOwnProperty('lotNumber')"
                  v-model="task.model.lotNumber"
                  :rules="{ max: 20,
                            regex: /^[0-9]{1,11}$/ }"
                  solo
                  :label="$t('Номер торговой процедуры')"
                  data-type="int" />
            </v-col>
          </v-row>
          <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
            <v-col cols="12">
              <v-progress-linear :active="isLoading" color="loader" indeterminate />
            </v-col>
            <v-col class="mx-1">
              <general-error v-if="!!generalError" />
            </v-col>
          </v-row>
          <v-row v-if="success" class="my-0 py-0 mx-1">
            <v-col cols="12">
              <v-alert
                  class="text-center"
                  outlined
                  :value="success"
                  type="success">
                {{ $t('Успешно выполнено') }}
              </v-alert>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-btn
                id="saveBtn"
                v-test="{ btn: 'save' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="execute">
              {{ $t('запустить') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import ValidatableDateTimePicker from '@/components/reused/ui/ValidatableDateTimePicker.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { LOT_TYPE_ENUM } from '@/constants/enums'
  import { mapActions } from 'vuex'
  import { SCHEDULER } from '@/constants/store.js'
  import store from '@/store'
  import scheduler from '@/store/dynamic/scheduler'

  export default {
    components: {
      ValidatableCheckbox,
      GeneralError,
      ValidatableTextInput,
      ValidatableEnumCombobox,
      ValidatableDateTimePicker
    },
    data () {
      return {
        LOT_TYPE_ENUM,
        isLoading: false,
        success: false,
        tasks: [
          {
            id: 'synchronizeBiksWithCBR',
            description: 'Синхронизация справочника БИК и банковских реквизитов организаций с ЦБР',
            execute: false,
            method: this.synchronizeBiksWithCBRAction
          },
          {
            id: 'sendErrorsNotification',
            description: 'Информирование об ошибках в логах начиная с указанной даты',
            execute: false,
            method: this.sendErrorsNotificationAction,
            model: {
              date: this.$moment().utc().format()
            }
          },
          {
            id: 'sendProxyExpirationDateNotificationAction',
            description: 'Информирование о просроченных документах',
            execute: false,
            method: this.sendProxyExpirationDateNotificationAction,
            model: {
              interval: 30
            }
          },
          {
            id: 'sendContractPaymentExpirationDateNotification',
            description: 'Информирование о просроченных договорах организаций',
            execute: false,
            method: this.sendContractPaymentExpirationDateNotificationAction,
            model: {
              interval: 30
            }
          },
          {
            id: 'sendLotCommissionNotification',
            description: 'Рассылка Реестра по начисленным комиссионным сборам',
            execute: false,
            method: this.sendLotCommissionNotificationAction
          },
          {
            id: 'sendActivityStatisticsNotification',
            description: 'Информирование администраторов об оплате услуг, если была активность в СЭТ ВР',
            execute: false,
            method: this.sendActivityStatisticsNotificationAction
          },
          {
            id: 'winnerAutoSelection',
            description: 'Подведение итогов (при запуске ранее <OrganizerSelectWinnerTime> подводятся итоги только по предыдущим торговым дням)',
            execute: false,
            method: this.winnerAutoSelectionAction,
            model: {
              lotNumber: null
            }
          },
          {
            id: 'sendLotPublicationNotification',
            description: 'Рассылка оповещения о публикации торговых процедур на сегодня',
            execute: false,
            method: this.sendLotPublicationNotificationAction
          },
          {
            id: 'attachLotOffersRegistry',
            description: 'Генерация документа "Реестр ценовых предложений" для торговых процедур (при запуске ранее <EndSessionTimeMax> сгенерируется только по предыдущим торговым дням)',
            execute: false,
            method: this.attachLotOffersRegistryAction
          }
        ]
      }
    },
    beforeCreate () {
      if (!store.hasModule(SCHEDULER.NAMESPACE)) {
        store.registerModule(SCHEDULER.NAMESPACE, scheduler)
      }
    },
    destroyed () {
      if (store.hasModule(SCHEDULER.NAMESPACE)) {
        store.unregisterModule(SCHEDULER.NAMESPACE)
      }
    },
    methods: {
      ...mapActions(SCHEDULER.NAMESPACE, {
        winnerAutoSelectionAction: SCHEDULER.ACTIONS.WINNER_AUTO_SELECTION,
        synchronizeBiksWithCBRAction: SCHEDULER.ACTIONS.SYNCHRONIZE_BIKS_WITH_CBR,
        sendLotCommissionNotificationAction: SCHEDULER.ACTIONS.SEND_LOT_COMMISSION_NOTIFICATION,
        sendContractPaymentExpirationDateNotificationAction: SCHEDULER.ACTIONS.SEND_CONTRACT_PAYMENT_EXPIRATION_DATE_NOTIFICATION,
        sendProxyExpirationDateNotificationAction: SCHEDULER.ACTIONS.SEND_PROXY_EXPIRATION_DATE_NOTIFICATION,
        sendErrorsNotificationAction: SCHEDULER.ACTIONS.SEND_ERRORS_NOTIFICATION,
        sendActivityStatisticsNotificationAction: SCHEDULER.ACTIONS.SEND_ACTIVITY_STATISTICS_NOTIFICATION,
        sendLotPublicationNotificationAction: SCHEDULER.ACTIONS.SEND_LOT_PUBLICATION_NOTIFICATION,
        attachLotOffersRegistryAction: SCHEDULER.ACTIONS.ATTACH_LOT_OFFER_REGISTRY
      }),
      execute: async function () {
        try {
          this.isLoading = true
          this.success = false
          const tasks = this.tasks.filter(t => t.execute)
          if (!tasks.length) {
            throw new Vue.errorsTypes.ValidationError(this.$t('Задачи не выбраны'))
          }
          await Promise.all(tasks.map(t => t.method(t.model || null)))
          this.success = true
        } catch (error) {
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
